<div class="page-container">
    <div class="d-flex justify-content-center flex-column align-items-center">
        <img class="logo" src="../../../../assets/images/admore-logo.svg" alt="">
        <img class="login-img" src="../../../../assets/images/login-img.png" alt="">
    </div>
    <p-card>
        <h2 class="welcom-span">Welcom !</h2>
        <h1 class="page-title">Sign in to </h1>
        <!-- <p class="description">Lorem Ipsum is simply </p> -->
        <form action="" [formGroup]="loginForm">
            <div class="custom-input-container">
                <label for="">Email</label>
                <input type="email" placeholder="Enter your email" formControlName="email">
                <app-form-errors [control]="loginForm.controls['email']"></app-form-errors>
            </div>
            <div class="custom-input-container">
                <label for="">Password</label>
                <div class="password-wrapper">
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      placeholder="Enter your password"
                      formControlName="password"
                    />
                    <i
                      class="pi"
                      [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
                      (click)="togglePasswordVisibility()"
                    ></i>
                  </div>
                
                <app-form-errors [control]="loginForm.controls['password']"></app-form-errors>
            </div>

            <div class="d-flex align-items-center mt-3 mb-3 gap-2">
                <p-checkbox [binary]="true" inputId="rememberMe" [(ngModel)]="rememberMe"
                    [ngModelOptions]="{standalone: true}" />
                <label for="rememberMe">Remember Me</label>
            </div>

            <div class="d-flex justify-content-center">
                <button pButton class="custom-btn bg-blue w-100" [loading]="loadingSubmit" (click)="submit()">Sign In</button>
            </div>
        </form>
    </p-card>
</div>